import InvoiceModal from "@/components/Customers/CustomerDetails/InvoiceModal";
import OGOSettings from "@/components/Integration/Delivery/OGOSettings";
import ProductionOrderDetailsModal from "@/components/ProductionOrders/ProductionOrderDetailsModal";
import PurchaseOrderDetailsModal from "@/components/PurchaseOrders/PurchaseOrderDetailsModal";
import StockUpdateOrderDetailsModal from "@/components/StockUpdateOrders/StockUpdateOrderDetailsModal";
import TransferOrderDetailsModal from "@/components/TransferOrders/TransferOrderDetailsModal";
import instance from "@/store/actions/instance";
import { message } from "antd";
import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";

const fetchOrderDetails = async (id) => {
  try {
    let res;
    if (id.startsWith("PO-")) {
      res = await instance.get(
        `get_purchase_orders/${id}?fetchInvoiceDetails=True`,
        { "axios-retry": { retries: 0 } }
      );
      return { selectedOrder: res.data, orderType: "purchase" };
    } else if (id.startsWith("ST-")) {
      res = await instance.get(
        `get_transfer_orders/${id}?fetchInvoiceDetails=True`,
        { "axios-retry": { retries: 0 } }
      );
      return { selectedOrder: res.data, orderType: "transfer" };
    } else if (id.startsWith("PD-")) {
      res = await instance.get(
        `get_production_orders/${id}?fetchInvoiceDetails=True`,
        { "axios-retry": { retries: 0 } }
      );
      return { selectedOrder: res.data, orderType: "production" };
    } else if (id.startsWith("SU-")) {
      res = await instance.get(
        `get_stock_update_orders/${id}?fetchInvoiceDetails=True`,
        { "axios-retry": { retries: 0 } }
      );
      return { selectedOrder: res.data, orderType: "stock-update" };
    } else {
      res = await instance.get(
        `/get_order_details/${"order"}/${id}/?fetchInvoiceDetails=True`,
        { "axios-retry": { retries: 0 } }
      );
      return { selectedOrder: res.data, orderType: "order" };
    }
  } catch (err) {
    return { selectedOrder: null, orderType: null };
  }
};
function InvoiceViewer({ selectedOrderReference, setLoading, onClose, t }) {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderType, setOrderType] = useState(null);

  const getRecordReferenceDetails = async () => {
    setLoading?.(true);
    const { selectedOrder, orderType } = await fetchOrderDetails(
      selectedOrderReference
    );
    console.log(t, "qwe");
    if (!selectedOrder) {
      message.error(t("SomethingWentWrong"));
      onClose();
      return;
    }
    setLoading?.(false);
    setSelectedOrder(selectedOrder);
    setOrderType(orderType);
  };

  useEffect(() => {
    getRecordReferenceDetails();
  }, []);

  return (
    <>
      {selectedOrder && orderType === "order" && (
        <InvoiceModal
          visible={true}
          selectedOrder={selectedOrder}
          onClose={onClose}
        />
      )}

      {selectedOrder && orderType === "purchase" && (
        <PurchaseOrderDetailsModal
          selectedOrder={selectedOrder}
          isViewOnly={true}
          onClose={onClose}
        />
      )}
      {selectedOrder && orderType === "transfer" && (
        <TransferOrderDetailsModal
          selectedOrder={selectedOrder}
          isViewOnly={true}
          onClose={onClose}
        />
      )}
      {selectedOrder && orderType === "stock-update" && (
        <StockUpdateOrderDetailsModal
          selectedOrder={selectedOrder}
          isViewOnly={true}
          onClose={onClose}
        />
      )}
      {selectedOrder && orderType === "production" && (
        <ProductionOrderDetailsModal
          selectedOrder={selectedOrder}
          isViewOnly={true}
          onClose={onClose}
        />
      )}
    </>
  );
}

export default withNamespaces()(InvoiceViewer);
